import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submitCountryForm(event) {
    event.target.form.requestSubmit()
  }
}
